var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 3C12.5019 3 9.66634 5.83553 9.66634 9.33333C9.66634 12.8311 12.5019 15.6667 15.9997 15.6667C19.4975 15.6667 22.333 12.8311 22.333 9.33333C22.333 5.83553 19.4975 3 15.9997 3Z",
    fill: "#CC09BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 19C12.966 19 10.175 19.4594 8.10608 20.2352C7.07533 20.6218 6.17173 21.1062 5.50784 21.6948C4.84512 22.2823 4.33301 23.059 4.33301 24C4.33301 24.941 4.84512 25.7177 5.50784 26.3052C6.17173 26.8938 7.07533 27.3782 8.10608 27.7648C10.175 28.5406 12.966 29 15.9997 29C19.0334 29 21.8244 28.5406 23.8933 27.7648C24.924 27.3782 25.8276 26.8938 26.4915 26.3052C27.1542 25.7177 27.6663 24.941 27.6663 24C27.6663 23.059 27.1542 22.2823 26.4915 21.6948C25.8276 21.1062 24.924 20.6218 23.8933 20.2352C21.8244 19.4594 19.0334 19 15.9997 19Z",
    fill: "#CC09BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon_user.eadc71790552ac84c9acd710f71ef9c8.svg";
export { ForwardRef as ReactComponent };